import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import AIFloatingButton from '../AIAgent/AIFloatingButton';
import useThemeStore from '../../store/themeStore';
import useAuthStore from '../../store/authStore';
import useSettingsStore from '../../store/settingsStore';

const { Content } = Layout;

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { initializeTheme } = useThemeStore();
  const { initializeAuth } = useAuthStore();
  const { fetchSettings } = useSettingsStore();

  useEffect(() => {
    // Initialize theme, auth, and settings on mount
    initializeTheme();
    initializeAuth();
    fetchSettings();
  }, [initializeTheme, initializeAuth, fetchSettings]);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar collapsed={collapsed} />
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 256,
          transition: 'margin-left 0.2s', // Smooth transition for collapse/expand
        }}
      >
        <Header collapsed={collapsed} onToggle={handleToggle} />
        <Content 
          id="main-content"
          className="m-6 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-soft animate-fade-in text-gray-900 dark:text-gray-100"
          style={{
            minHeight: 'calc(100vh - 112px)',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
      
      {/* AI Assistant - Available across the entire application */}
      <AIFloatingButton />
    </Layout>
  );
};

export default MainLayout;
